import { useContext } from 'react';
import './SearchResultsSectionSkeleton.styles.scss';
import '../../../components/Grid/Grid.styles.scss';
import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import Skeleton, { SkeletonShape } from '../../../components/Skeleton/Skeleton';
import { GlobalContext } from '../../../GlobalContext';

interface iSearchResultsSectionSkeletonProps {
    title: string;
    tilesCount: number;
}

const SearchResultsSectionSkeleton = ({ title, tilesCount }: iSearchResultsSectionSkeletonProps) => {
    const { getRem } = useContext(GlobalContext);
    const itemWidth = `calc((100% - ${getRem(tilesCount * 8)}px) / ${tilesCount})`;

    return (
        <output
            className="GlobalSearch__result SearchResultsSectionSkeleton"
            aria-busy="true"
            aria-label={`Loading ${title}`}
        >
            <div className={`Grid Grid--${tilesCount}`}>
                <div className="Grid__title">
                    <SectionTitle text={title} subText={<Skeleton width={120} height={14} radius={2} aria-hidden="true" />} />
                </div>
                <div className="Grid__items">
                    {Array.from({ length: tilesCount }).map((_, index) => (
                        <div key={index} className="Grid__item" style={{ width: itemWidth, maxWidth: itemWidth }}>
                            <Skeleton
                                shape={SkeletonShape.Rect}
                                className="SearchResultsSectionSkeleton__tile"
                                aria-hidden="true"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </output>
    );
};

export default SearchResultsSectionSkeleton;
